module.exports = __webpack_public_path__ + "static/img/aiAbility-img3.01ade17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/keyFeaturesPhone/aiAbility-img3.png
// module id = njVM
// module chunks = 0